export const focus = {
  inserted: function (el) {
    el.focus()
  }
};



// WEBPACK FOOTER //
// ./src/directives/focus.js